import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import { GETREQUEST } from "../../helpers/ServiceRequest";

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [SearchBuyerCode, setSearchBuyerCode] = useState("");
  const [SearchCustomerCode, setSearchCustomerCode] = useState("");
  const [SearchCustomerName, setSearchCustomerName] = useState("");
  const [current, setCurrent] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [totalItems, setTotalItems] = useState();
  const [page, setPage] = useState(0);
  const [sortColumn, setSortColumn] = useState("CustomerCode");
  const [sortBy, setSortBy] = useState("ASC");
  const [size, setSize] = useState(100);
  const [currentPage, setCurrentPage] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight - 20 + "px");
  });
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let URL = process.env.REACT_APP_API_URL + `/get-customers?page=${page}&size=${size}`;
      let queryParams = []

      if (SearchCustomerCode) queryParams.push(`searchCustomerCode=${SearchCustomerCode}`);
      if (SearchBuyerCode) queryParams.push(`searchBuyerCode=${SearchBuyerCode}`);
      if (SearchCustomerName) queryParams.push(`searchCustomerName=${SearchCustomerName}`);
      if (sortColumn && sortBy) queryParams.push(`sortColumn=${sortColumn}&sortBy=${sortBy}`);
      if (current) queryParams.push(`current=${current}`);

      if (queryParams.length > 0) URL += `&${queryParams.join('&')}`;

      // if(current != "" && searchText != ""){
      //   URL = URL + `&current=${current}&searchText=${searchText}`;
      // }else if(current != ""){
      //   URL = URL + `&current=${current}`;
      // } else if(searchText != ""){
      //   URL = URL + `&searchText=${searchText}`;
      // }
      let response = await GETREQUEST(URL, user.jwtToken, false);
      if (response?.data) {
        setLoading(false);
        setCustomers(response.data.data);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setCurrentPage(response.data.currentPage);
      }
    }
    fetchData();
  }, [searchText, current, page, size, sortColumn, sortBy, SearchBuyerCode, SearchCustomerCode, SearchCustomerName]);
  const handleSort = (sortName) => {
    setSortColumn(sortName);
    if (sortBy == "")
      setSortBy("ASC")
    else if (sortBy == "ASC")
      setSortBy("DESC")
    else
      setSortBy("ASC")
  }

  const getStartPageIndex = () => {
    return page === 0 ? 1 : page * size + 1;
  };

  const getEndPageIndex = () => {
    if (page === 0) {
      return customers.length;
    }
    const endIndex = (page + 1) * size;
    return endIndex > totalItems ? totalItems : endIndex;
  };

  return (
    <React.Fragment>
      <Header />

      <main>
        <section className="p-4 overflow-hidden table-listing">
          <div className="table-elements">
            <div className="paginations d-flex align-items-center p-2">
              <p className="fs-14 text-lite mb-1 me-2">
                Showing Results{" "}
                <span className="text-dark">{totalItems == 0 ? 0 : getStartPageIndex()}</span> -{" "}
                <span className="text-dark">{getEndPageIndex()}</span> of{" "}
                <span className="text-dark">{totalItems}</span>
              </p>
              <ul className="list-inline mb-1">
                {currentPage > 0 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page - 1)}>
                      {" "}
                      <i className={`bi bi-chevron-left text-light`}></i>{" "}
                    </a>
                  </li>
                )}
                {totalPages > currentPage + 1 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page + 1)}>
                      {" "}
                      <i className={`bi bi-chevron-right text-dark`}></i>{" "}
                    </a>
                  </li>
                )}
              </ul>
              <div style={{ marginLeft: "10px" }}>
                <select
                  className="form-select input-sm cme-10"
                  aria-label="Page size select example"
                  style={{ width: "100px" }}
                  value={size}
                  onChange={(e) => { setSize(e.target.value); setPage(0) }}
                >
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card border-bottom-0 w-100">
            <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap overflow-auto">
              <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Customers
              </h1>
              <div className="filter-elements d-flex align-items-center">
                {/* <div className="input-group flex-nowrap cme-10 me-0">
                  <div
                    type="button"
                    className="btn btn-outline-light hover-none border-end-0 d-flex align-items-center pe-0"
                  >
                    <i className="bi bi-search"></i>
                  </div>
                  <input
                    type="text"
                    className="form-control input-sm border-start-0 search"
                    placeholder="Search by Customer Name"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div className="custom-group flex-nowrap">
                  <select
                    className="form-select input-sm cme-10"
                    aria-label="Default select example"
                    style={{ minWidth: "168px" }}
                    onChange={(e) => setCurrent(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>
                    <option value="2">Inactive</option>
                  </select>
                  <Link
                    to="/create-customer"
                    className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                  >
                    <i className="icon icon-add cpe-5 fs-13"></i>Add Customer
                  </Link>
                </div> */}
                <Link
                  to="/create-customer"
                  className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                >
                  <i className="icon icon-add cpe-5 fs-13"></i>Add Customer
                </Link>
              </div>
            </div>
            <div className="card-body p-0 border-bottom">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      {/* Buyer Code */}
                      <th scope="col" className=" col width-sm-auto">
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('BuyerCode')}>Buyer Code</span>
                          {sortColumn == "BuyerCode" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Buyer Code"
                            onChange={(e) => setSearchBuyerCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-sm-auto">
                        {/* Customer Code */}

                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('CustomerCode')}>Customer Code</span>
                          {sortColumn == "CustomerCode" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Customer Code"
                            onChange={(e) => setSearchCustomerCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-70 width-sm-auto">
                        <span style={{ cursor: "pointer" }} onClick={() => handleSort('CustomerName')}>Customer Name</span>
                        {sortColumn == "CustomerName" &&
                          <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                        }
                        <div className="w-25 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Customer Name"
                            onChange={(e) => setSearchCustomerName(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-70 width-sm-auto">
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('Current')}>Status</span>
                          {sortColumn == "Current" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <select
                          className="form-select input-sm cme-10"
                          aria-label="Default select example"
                          style={{ width: "168px" }}
                          onChange={(e) => setCurrent(e.target.value)}
                        >
                          <option value={""}>All</option>
                          <option value={1} selected>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </th>
                      <th scope="col" className="width-lg-5 width-sm-auto">
                        <span style={{ position: "absolute", top: "22px" }}>Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="position-relative">
                    {loading && (
                      <tr className="position-absolute w-100 ">
                        <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                          <div className="overlay">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {customers.length == 0 && (
                      <tr>
                        <td colSpan={5} className="text-center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                    {customers.map((customer, index) => {
                      return (
                        <tr key={index}>
                          <td>{customer.BuyerCode}</td>
                          <td>{customer.CustomerCode}</td>
                          <td>{customer.CustomerName}</td>
                          <td>
                            <span
                              className={
                                "badge statusBadge border  fw-medium  px-4 fs-13 cpy-7 " +
                                (customer.Current === 1
                                  ? "border-success text-success bg-success-lite"
                                  : "border-warning text-warning bg-warning-lite")
                              }
                            >
                              {customer.Current === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <Link
                              to={'/update-customer/' + customer.CustomerID}
                              className="btn btn-outline-lite btn-xs d-inline-flex align-items-center text-dark"
                            >
                              View/Edit
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default Customers;
